export const subscriptionsReducer = (state = [], action) => {
    switch (action.type) {
        case 'GET_SUBSCRIPTION_DETAILS':
            return {
                ...state,
                subscriptions: action.payload,
                loading: false
            }
        case 'LOADING_TABLES':
            return{
                ...state,
                loading: true
            }
        case 'QUICK_UPDATE_SUBSCRIPTION_SLOTS_AND_LOCATIONS':
            const { slots, location_id, plan_name, subscription_id } = action.payload;

            const updatedSubscriptions = state?.subscriptions?.data?.map(sub => {
                if (sub.id !== subscription_id) return sub;

                const updatedProductSlots = sub.product_slots.map(slot => {
                    const newSlotData = slots.find(s => s.product.plan_id === slot.product.plan_id);
                    return newSlotData
                        ? {
                            ...slot,
                            slots: newSlotData.slots,
                            slots_used: newSlotData.slots_used
                        }
                        : slot;
                });

                const updatedLocations = sub.locations.map(loc =>
                    loc.location_id == location_id
                        ? {
                            ...loc,
                            product: {
                                ...loc.product,
                                name: plan_name
                            }
                        }
                        : loc
                );
                return {
                    ...sub,
                    product_slots: updatedProductSlots,
                    locations: updatedLocations
                };
            });

            return {
                ...state,
                subscriptions: {data: updatedSubscriptions}
            };
        case "QUICK_ADD_LOCATION_TO_SUBSCRIPTION": {
            const { newLocation, subscription_id } = action.payload;

            const updatedSubscriptions = state.subscriptions?.data?.map(sub => {
                if (sub.id !== subscription_id) return sub;

                return {
                    ...sub,
                    locations: [...sub.locations, newLocation]
                };
            });

            return {
                ...state,
                subscriptions: {data: updatedSubscriptions}
            };
        }
        case 'CLEAR_SUBSCRIPTIONS':
            return {
                ...state,
                subscriptions: undefined
            }
            const cardIdToDelete = action.payload.cardId;

            // Filter out the deleted card from cards.data
            const updatedData = state.subscriptions.cards.data.filter(card => card.id !== cardIdToDelete);
            // Update locations to clear expiration_month and expiration_year for the deleted card
            const updatedDeletedLocationsAll = state.subscriptions.locations.all.map(location =>
                location.card_id === cardIdToDelete ?
                    { ...location, expiration_month: '', expiration_year: '', card: null, card_type: "" } : location
            );

            return {
                ...state,
                subscriptions: {
                    ...state.subscriptions,
                    cards: {
                        ...state.subscriptions.cards,
                        data: updatedData
                    },
                    locations: {
                        ...state.subscriptions.locations,
                        all: updatedDeletedLocationsAll
                    }
                }
            };
        default:
            return {
                ...state
            }
    }
}

export const plansReducer = (state = [], action) => {
    switch (action.type) {
        case 'GET_PLANS':
            return {
                ...state,
                plans: action.payload
            }
        default:
            return {
                ...state
            }
    }
}

export const couponsReducer = (state = [], action) => {
    switch (action.type) {
        case 'GET_COUPONS':
            return {
                ...state,
                coupons: action.payload
            }
        default:
            return {
                ...state
            }
    }
}

export const subscriptionReducer = (state = {}, action) => {
    switch (action.type) {
        case 'GET_SUBSCRIPTION':
            return {
                ...state,
                subscription: action.payload
            }
        case 'CLEAR_SUBSCRIPTION':
            return{
                ...state,
                subscription: undefined
            }
        case 'UPDATE_SUBSCRIPTION_SLOTS_AND_LOCATIONS':
            const { slots, location_id, plan_name } = action.payload;

            const updatedProductSlots = state.subscription?.data?.product_slots.map(slot => {
                const newSlotData = slots.find(s => s.product.plan_id === slot.product.plan_id);
                return newSlotData
                    ? {
                        ...slot,
                        slots: newSlotData.slots,
                        slots_used: newSlotData.slots_used
                    }
                    : slot;
            });

            const updatedLocations = state.subscription?.data?.locations.map(loc =>
                loc.location_id == location_id
                    ? {
                        ...loc,
                        product: {
                            ...loc.product,
                            name: plan_name
                        }
                    }
                    : loc
            );
            return {
                ...state,
                subscription: {
                  ...state.subscription,
                  data: {
                    ...state.subscription.data,
                    product_slots: updatedProductSlots,
                    locations: updatedLocations
                  }
                }
            };
        case 'ADD_DEMO_LOCATIONS':
            return {
                ...state,
                subscription: {
                  ...state.subscription,
                    data: {
                        ...state.subscription.data,
                        locations: [
                            ...(state.subscription?.data?.locations || []),
                            ...(action.payload.newLocations || [])
                        ]
                    }
                }
            };
        case 'UPDATE_SUBSCRIPTION_CARD_ID':
            const card_id  = action.payload;

            const updatedCardPaymentMethod = state.subscription?.data?.payment_method
                ? {
                    ...state.subscription.data.payment_method,
                    details: {
                        ...state.subscription.data.payment_method.details,
                        card_id: card_id
                    }
                }
                : null;

            return {
                ...state,
                subscription: {
                    ...state.subscription,
                    data: {
                        ...state.subscription.data,
                        payment_method: updatedCardPaymentMethod
                    }
                }
            };
        case 'UPDATE_SUBSCRIPTION': {
            const { newSubscription } = action.payload;
            return {
                ...state,
                subscription: {
                    data: {
                        ...state.subscription.data,  
                        ...newSubscription,         
                        locations: state.subscription.data?.locations || [] 
                    }
                }
            };
        }
        case 'ADD_LOCATION_TO_SUBSCRIPTION':
            return {
                ...state,
                subscription: {
                  ...state.subscription,
                  data: {
                    ...state.subscription.data,
                    locations: [...state.subscription?.data?.locations, action.payload.newLocation]
                  }
                }
            };
        default:
            return {
                ...state
            }
    }
}